module.exports = __webpack_public_path__ + "img/avatar-s-11.14cf1734.jpg";